(function($){
    function loadComments() {
        var comment_service = $(this).data("comments-service") || "";
        var comment_template = $(this).data("comments-template") || "";
        if (!comment_service || !comment_template) {
            return;
        }

        switch(comment_service) {
            case 'facebook':
                $(this).after(comment_template);
                $(this).remove();
                FB.XFBML.parse();
            break;

            case 'spot-im':
                $(this).after(comment_template);
                $(this).remove();
            break;

            default:
                var _tmp = window.console &&
                    window.console.error("'loadDesktopCommentsOnClick' not supported for - " + comment_service);
            break;
        }

        return;
    }

    $('#load-comments-btn').on('click', loadComments);
    return;
})(jQuery);
